/* NORAH · Shows the "$" amounts written in promo texts (announcement bar, cart bundle bar,
   cart carousel title, popup) in the customer's currency, using Shopify's active rate.
   Example: "SAVE $50" -> "SAVE £50" (UK) or "SAVE €47" (EU, if the rate is 0.94).
   To use it in another text, add data-nr-money to the element. */
(function () {
  var cur = window.Shopify && window.Shopify.currency;
  if (!cur || !cur.active) return;
  var code = cur.active;
  var rate = parseFloat(cur.rate) || 1;
  if (code === 'USD' && rate === 1) return;

  var SEL = '.announcement-bar__message, .nr-cd__bmsg, .nr-cd__bar-labels, .nr-upsell__heading, .nr-cd__line--discount, .nr-pop, [data-nr-money]';
  var RE = /\$\s?(\d{1,3}(?:,\d{3})*(?:\.\d+)?|\d+(?:\.\d+)?)/g;
  var nf;
  try {
    nf = new Intl.NumberFormat('en', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  } catch (e) {
    return;
  }
  function conv(m, num) {
    var n = parseFloat(num.replace(/,/g, ''));
    if (isNaN(n)) return m;
    return nf.format(Math.round(n * rate));
  }
  function fix(el) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.indexOf('$') === -1) continue;
      var parent = node.parentNode;
      if (parent && (parent.nodeName === 'SCRIPT' || parent.nodeName === 'STYLE')) continue;
      node.nodeValue = node.nodeValue.replace(RE, conv);
    }
    if (el.hasAttribute('aria-label') && el.getAttribute('aria-label').indexOf('$') > -1) {
      el.setAttribute('aria-label', el.getAttribute('aria-label').replace(RE, conv));
    }
  }
  function run(root) {
    (root || document).querySelectorAll(SEL).forEach(fix);
    (root || document).querySelectorAll('.nr-cd__bar[aria-label]').forEach(fix);
  }
  function boot() {
    run();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 30);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
